import { TranslateLoader } from "@ngx-translate/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from "rxjs";

import { environment } from './../../../environments/environment';

const translationsUrl = '/translations'

export class TranslateCustomHttpLoader implements TranslateLoader {
  constructor (private http: HttpClient) { }

  public getTranslation(lang: string): Observable<any> {
    let params = new HttpParams()

    params = params.set('language', lang)

    return this.http.get(`${environment.baseApiUrl}${translationsUrl}`, { params: params })
  }
}
